import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Tag} from '../models/tag';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(private http: HttpClient) {
  }

  findByUserActiveRegion(regionSlug: string) {
    return this.http.get<Tag[]>(`${API}/api/tags/user/active/${regionSlug}`);
  }

  findByPlaceActiveRegion(regionSlug: string) {
    return this.http.get<Tag[]>(`${API}/api/tags/place/active/${regionSlug}`);
  }

  findByPostActiveRegion(regionSlug: string) {
    return this.http.get<Tag[]>(`${API}/api/tags/post/active/${regionSlug}`);
  }

  findBySessionActiveRegion(regionSlug: string) {
    return this.http.get<Tag[]>(`${API}/api/tags/session/active/${regionSlug}`);
  }

}
